import { Customer } from "../../components/auth/Auth";

export const FETCH_CUSTOMERS_REQUEST = "FETCH_CUSTOMERS_REQUEST";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAIL = "FETCH_CUSTOMERS_FAIL";

export const ADD_CUSTOMER_REQUEST = "ADD_CUSTOMER_REQUEST";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_FAIL = "ADD_CUSTOMER_FAIL";

export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";

export interface FetchCustomersRequestAction {
    type: typeof FETCH_CUSTOMERS_REQUEST;
}

export interface FetchCustomersSuccessAction {
    type: typeof FETCH_CUSTOMERS_SUCCESS;
    payload: Customer[];
}

export interface FetchCustomersFailAction {
    type: typeof FETCH_CUSTOMERS_FAIL;
    payload: Error;
}

export interface AddCustomerRequestAction {
    type: typeof ADD_CUSTOMER_REQUEST;
}

export interface AddCustomerSuccessAction {
    type: typeof ADD_CUSTOMER_SUCCESS;
}

export interface AddCustomerFailAction {
    type: typeof ADD_CUSTOMER_FAIL;
    payload: Error;
}

export interface DeleteCustomerRequestAction {
    type: typeof DELETE_CUSTOMER_REQUEST;
}

export interface DeleteCustomerSuccessAction {
    type: typeof DELETE_CUSTOMER_SUCCESS;
}

export interface DeleteCustomerFailAction {
    type: typeof DELETE_CUSTOMER_FAIL;
    payload: Error;
}

export type ActionTypes =
    | FetchCustomersRequestAction
    | FetchCustomersSuccessAction
    | FetchCustomersFailAction
    | AddCustomerRequestAction
    | AddCustomerSuccessAction
    | AddCustomerFailAction
    | DeleteCustomerRequestAction
    | DeleteCustomerSuccessAction
    | DeleteCustomerFailAction;